<div class="bg" *ngIf="popup" (click)="onBackground()"></div>
<overlay-scrollbars>
    <div class="inner">
        <app-button type="header" [key]="type+'.title'"></app-button>
        <div class="text" [innerHTML]="type+'.text' | wording"></div>
    </div>
</overlay-scrollbars>